import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosApiInstance } from "../lib/axios";
import { API_PORTAL_URL } from "../lib/config";

export const getAllActiveAttractions = createAsyncThunk(
  "Attraction/FindAllActiveAttraction",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/Attraction/FindAllActiveAttraction`,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Attractions:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAttractionsByURL = createAsyncThunk(
  "Attraction/AttractionFindByURL",
  async (AttractionURL: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Attraction/AttractionFindByURL`,
        { AttractionURL },
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error fetching Attractions :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export interface AttractionsState {
  loading: boolean;
  error: string;
  attractionDetails: any;
  AttractionsList: any[];
}

const initialState: AttractionsState = {
  loading: false,
  error: "",
  attractionDetails: null,
  AttractionsList: [],
};

const attractionsSlice = createSlice({
  name: "attractions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllActiveAttractions.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllActiveAttractions.fulfilled, (state, action) => {
      state.loading = false;
      state.AttractionsList = action.payload || [];
      state.error = "";
    });
    builder.addCase(getAllActiveAttractions.rejected, (state, action) => {
      state.loading = false;
      state.AttractionsList = [];
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAttractionsByURL.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAttractionsByURL.fulfilled, (state, action) => {
      state.loading = false;
      state.attractionDetails = action.payload;
      state.error = "";
    });
    builder.addCase(getAttractionsByURL.rejected, (state, action) => {
      state.loading = false;
      state.attractionDetails = null;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export default attractionsSlice.reducer;
